const cardItems = [
  {
    id: 1,
    title: '豆瓣8.5+高分华语电影大赏',
    desc: '整理近十年华语佳片，从文艺到商业，每部都经得起时间考验的经典之作。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20film%20camera%20and%20film%20reels%20with%20warm%20vintage%20amber%20lighting%2C%20classic%20cinema%20aesthetic%2C%20nostalgic%20atmosphere%2C%20soft%20natural%20light%2C%20artistic%20composition%2C%20golden%20hour%20tones&width=600&height=380&seq=card-01-90movies&orientation=landscape',
    meta: '编辑精选 · 2天前',
  },
  {
    id: 2,
    title: '2026年最值得期待的海外新剧',
    desc: 'Netflix、HBO、Apple TV+年度片单抢先看，追剧日历已为你整理完毕。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20TV%20setup%20with%20multiple%20screens%20displaying%20dramatic%20scenes%2C%20cozy%20dark%20room%20with%20warm%20ambient%20lighting%2C%20entertainment%20technology%2C%20cinematic%20atmosphere&width=600&height=380&seq=card-02-90movies&orientation=landscape',
    meta: '新剧速递 · 1天前',
  },
  {
    id: 3,
    title: '冷门但惊艳的小众文艺片推荐',
    desc: '国际电影节获奖佳作，你可能错过了但这些电影绝对值得一看再看。',
    img: 'https://readdy.ai/api/search-image?query=Art%20house%20cinema%20interior%20with%20warm%20dim%20lighting%2C%20vintage%20movie%20posters%20on%20wall%2C%20cozy%20atmosphere%2C%20independent%20film%20aesthetic%2C%20soft%20textures%2C%20golden%20and%20deep%20red%20tones&width=600&height=380&seq=card-03-90movies&orientation=landscape',
    meta: '深度推荐 · 3天前',
  },
  {
    id: 4,
    title: '家庭观影指南：老少皆宜的合家欢',
    desc: '周末宅家必备片单，从动画到真人电影，全家人一起享受温馨观影时光。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20family%20watching%20TV%20together%2C%20soft%20evening%20light%2C%20comfortable%20atmosphere%2C%20happy%20family%20moment%2C%20home%20theater%20aesthetic%2C%20golden%20ambient%20glow&width=600&height=380&seq=card-04-90movies&orientation=landscape',
    meta: '观影指南 · 4天前',
  },
  {
    id: 5,
    title: '原著党必看：小说改编影视作品',
    desc: '从经典文学到热门网文，这些改编作品还原度爆表，原著粉都拍手叫好。',
    img: 'https://readdy.ai/api/search-image?query=Stack%20of%20old%20books%20next%20to%20a%20film%20projector%2C%20warm%20library%20lighting%2C%20vintage%20reading%20room%20atmosphere%2C%20cinema%20and%20literature%20fusion%2C%20dust%20particles%20in%20sunlight%2C%20nostalgic%20feel&width=600&height=380&seq=card-05-90movies&orientation=landscape',
    meta: '原著改编 · 5天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            编辑精选
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            编辑团队精心挑选的优质影视内容与深度观影指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-secondary-200/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <span className="text-[10px] text-foreground-400 uppercase tracking-wide mb-1.5 whitespace-nowrap">
                  {item.meta}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}